import React, { useEffect, useState } from 'react';
import './inventaire.css';
import Filtres from './Filtres';
import ModalNouvelItem from '../../modal/ModalNouvelItem';
import ModalItemDescriptionShop from '../../modal/ModalItemDescriptionShop';
import { moneyMaker } from '../../../utils';
import axios from 'axios';
import { ReactComponent as Taria_Gold } from '../../../svg/Taria_Gold.svg';
import { ReactComponent as Taria_Silver } from '../../../svg/Taria_Silver.svg';
import { ReactComponent as Taria_Bronze } from '../../../svg/Taria_Bronze.svg';

const PageShop = ({ tags, categories,token }) => {

  const [filteredItems, setFilteredItems] = useState([]);
  const [items, setItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [shownItems, setShownItems] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenNew, setModalOpenNew] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpenDesc, setIsModalOpenDesc] = useState(false);
  const [tagSelected, setTagSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const ip = process.env.REACT_APP_IP;
  const fetchItems = async () => {
    try {
      const responseItems = await axios.get(`${ip}/items`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
    });
      setItems(responseItems.data);
      setIsLoading(false);
    } catch (error) {
      console.error('Une erreur s\'est produite lors de la récupération des items :', error);
      setError('Une erreur s\'est produite lors de la récupération des items.');
      setIsLoading(false);
    }
  };
  useEffect(() => {

    fetchItems();
  }, [ip]);




  const filterItems = () => {
    let result = items;
    if (tagSelected.length > 0) {
      result = result.filter(item =>
        tagSelected.some(selectedTag => item.tags.includes(selectedTag.nom))
      );
    } 
    setFilteredItems(result);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleClick = (e) => {
    setSelectedItem(e);
    setIsModalOpenDesc(!isModalOpenDesc);
  };


  useEffect(() => {
    filterItems();
  }, [items, tagSelected]);

  useEffect(() => {
    fetchItems();
  }, [modalOpenNew]);
  
  useEffect(() => {
    if (searchQuery.trim() === '') {
      setShownItems(filteredItems);
    } else {
      const searchedItems = filteredItems.filter(item =>
        item.item_nom.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setShownItems(searchedItems);
    }
  }, [searchQuery, filteredItems]);

  if (isLoading) {
    return <div>Chargement...</div>;
  }
  if (error) {
    return <div>{error}</div>;
  }
  return (
    <div className="table_wrap_equipement">
      <div className='search_wrapper_equipement'>
        <input
          type='text'
          className='search_bar_equipement'
          placeholder='Recherche...'
          value={searchQuery}
          onChange={handleSearch}
        />
      </div>
      <div className='search_wrapper_equipement'>
        {/* <button
          className='filtre_button_equipement'
          onClick={() => setModalOpen(!modalOpen)}
        >
          Filtres
        </button>
        <Filtres
          isOpen={modalOpen}
          setOpen={setModalOpen}
          setTags={setTagSelected}
          tags={tags}
        /> */}
        <button
        className='filtre_button_equipement'
        onClick={() => setModalOpenNew(!modalOpenNew)}
        >
          Nouvel Objet
        </button>
        <ModalNouvelItem
          isOpen={modalOpenNew}
          setOpen ={setModalOpenNew}
          categories={categories}
          token={token}
        />
      </div>

      <div className='search_wrapper_equipement'>
        <table className="table_equipement">
          <tbody>
            {shownItems.slice(0, 20).map(item => (
              <tr
                key={item.idItem}
                className="table_row_equipement"
                onClick={() => handleClick(item)}
              >
                <td>
                  <div className='margin_1em'><span><strong>{item.item_nom}</strong></span></div>
                </td>
                <td className='info_equipement'>
                  <div className='margin_0_2em '>Quantité: {item.quantite}</div>
                  <div className='margin_0_2em flex align_center'>Valeur: <div className="modal_moneys flex">
                    <span>{moneyMaker(item.valeur).or}</span>
                    <Taria_Gold className="modal_money"></Taria_Gold>
                    <span>{moneyMaker(item.valeur).argent}</span>
                    <Taria_Silver className="modal_money"></Taria_Silver>
                    <span>{moneyMaker(item.valeur).bronze}</span>
                    <Taria_Bronze className="modal_money"></Taria_Bronze>
                  </div></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {selectedItem &&
        <ModalItemDescriptionShop
          isOpen={isModalOpenDesc}
          setOpen={setIsModalOpenDesc}
          item={selectedItem}
          token={token}
        />
      }

    </div>
  );
};

export default PageShop;
